import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { ButtonSet } from 'nrcs-design-system';
import { ProjectActions } from '../ProjectActions/ProjectActions';
import { ProjectCardVM, IProjectCardProps } from './ProjectCardVM';
import { formatMonthDayYear } from 'cd-eft/utils/formatDate';
import './ProjectCard.scss';

import stores from '../../../models/Stores';
const appConfig = stores.AppStore.appConfig;

const ProjectCardComponent = (props: IProjectCardProps) => {
  const { project } = props;
  const history = useHistory();
  const vm = useRef(new ProjectCardVM(props, history)).current;
  const projectDetailsFlag = appConfig.projectFlags.enableProjectDetails;

  const statusLevel = project.projectStatus;
  const projectStatus = statusLevel!.replace(/ /g, '').toLowerCase();

  return (
    <div>
      <Card className="project-card" data-testid="project-card">
        <CardHeader className="card-header">
          <Row className="card-header-row flex-align-center">
            <Col
              className={`project-name ${projectDetailsFlag ? 'link' : ''}`}
              onClick={projectDetailsFlag ? vm.handleClick : undefined}
            >
              <Link to={`/projects/${project.projectUuid}`} className="link-to-project">
                <div className="h4 m-0 pl-3">
                  <strong>Project Name: {project.projectTitle}</strong>
                </div>
              </Link>
              <div className={`status-level ${projectStatus}`}>{project.projectStatus}</div>
            </Col>

            <Col className="button-column">
              <ButtonSet className="button-group">
                <ProjectActions project={project} />
              </ButtonSet>
            </Col>
          </Row>
        </CardHeader>
        <CardBody
          className={`card-body ${projectDetailsFlag ? 'link' : ''}`}
          onClick={projectDetailsFlag ? vm.handleClick : undefined}
        >
          <Row xs={1} lg={2}>
            <Col className='pl-3'>
              <ul className="card-body-list">
                <li>
                  <b>Client Name: </b>
                  {project.client}
                  {project.client && (project.county || project.state) && ', '}
                  {project.county}
                  {project.county && project.state && ', '}
                  {project.state}
                </li>
                <li className="capitalize">
                  <b>Practice: </b>
                  {project.practice}
                  {project.practice && project.projectClassType ? ', ' : ''}
                  {project.projectClassType}
                </li>
              </ul>
            </Col>
            <Col className='pl-3'>
              <ul className="card-body-list">
                <li>
                  <b>Last Updated: </b>
                  <span className="capitalize">{project.lastChangedBy.split('@')[0].replace('.', ' ')}</span> on{' '}
                  {formatMonthDayYear(project.lastChangedDate)}
                </li>
                <li className="capitalize">
                  <b>Project Owner: </b>
                  {vm.newOwnerName}
                </li>
              </ul>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export const ProjectCard = observer(ProjectCardComponent);
